import { FETCH_POSTS, FETCH_POSTS_START, FETCH_POST } from '../actions';

const initialState = {
    fetched: false,
    failed: false,
    posts: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_POSTS_START:
            return { ...state, fetched: false, posts: [] };
        case FETCH_POSTS:
            return { ...state, fetched: true, posts: action.payload };
        case FETCH_POST:
            return { ...state, fetched: true, posts: action.payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/posts_reducer.jsx